import { WebshopProduct } from '@cldsystems/ws-api-client';
import { SimpleProductInfo } from '@/types/products/simple-product-info';
import { getCategoryId } from './get-category-id';

export const mapProductToSimpleProductInfo = (product: WebshopProduct): SimpleProductInfo => {
  return {
    id: product.id,
    sku: product.sku,
    name: product.name,
    description: product.description,
    locale: product.locale,
    price: product.price,
    discountedPrice: product.discountedPrice,
    meta: product.meta,
    display: product.display,
    discountValue: product.discountValue,
    discountType: product.discountType,
    images: product.images,
    discountedPriceType: 'NONE',
    parentCategoryId: getCategoryId(product.superCategories) || '',
  };
};
